export const server_api = 'https://artisan-server.onrender.com';
// export const server_api = 'http://localhost:6001';